module.exports = __webpack_public_path__ + "img/ISO20000-en.565a1ee4.jpg";